/**
 * Repair of a saved force (2026-10-24): the Brigade model wrote `brigade_type` (MECHANIZED, ARTILLERY ...) to JSON but not `unit_type`, so a force
 * that went through localStorage, a cloud save or a student snapshot came back with brigades that have no unit_type (Tab 1 'Not specified', the
 * brigade modifier 1.00, and a calculation without the brigade type). Brigade.toJSON now writes unit_type (Dr. Tatar, 2026-10-24: the typed
 * numbers are the ones that look right); this fills it from brigade_type for saves made before.
 * Pure: returns a new object when something was filled, the same object otherwise. Only brigades are touched (a battalion always had unit_type).
 */
import { normalizeUnitTypeKey } from '../constants/unitTypeRegistry';

const fillBrigade = (b) => {
  if (!b || typeof b !== 'object' || b.unit_type || !b.brigade_type) return b;
  return { ...b, unit_type: normalizeUnitTypeKey(b.brigade_type) };
};

export function fillBrigadeUnitTypes(result) {
  if (!result || typeof result !== 'object') return result;
  let out = result;
  const set = (key, value) => { if (value !== out[key]) out = { ...out, [key]: value }; };
  if (result.brigade) set('brigade', fillBrigade(result.brigade));
  if (Array.isArray(result.brigades)) {
    const brigades = result.brigades.map(fillBrigade);
    if (brigades.some((b, i) => b !== result.brigades[i])) set('brigades', brigades);
  }
  return out;
}

/** The scenario with the brigades of its force filled (force.forceBuilderResult and the flattened force.brigades). */
export function repairScenarioForce(scenario) {
  const force = scenario?.force;
  if (!force) return scenario;
  const result = fillBrigadeUnitTypes(force.forceBuilderResult);
  const flat = Array.isArray(force.brigades) ? force.brigades.map(fillBrigade) : force.brigades;
  const flatChanged = Array.isArray(flat) && flat.some((b, i) => b !== force.brigades[i]);
  if (result === force.forceBuilderResult && !flatChanged) return scenario;
  return { ...scenario, force: { ...force, forceBuilderResult: result, ...(flatChanged ? { brigades: flat } : {}) } };
}
